import column from './column.vue';
export default {
    components: {
        column
    },
    data: function() {
        return {
            fullColumn: false,
            title: '',
            html: '',
            columns: [],
            bgType: '',
            bgColor: '',
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            },
            columnbgColor: '',
            mobileNoMargin: false
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        useBgSrc() {
            if (!this.isMobileSize) {
                return this.bgImgOpt.src || this.bgImgOpt.mobileSrc;
            } else {
                return this.bgImgOpt.mobileSrc || this.bgImgOpt.src;
            }
        }
    }
};
